import { PlayerPayPopup } from "/app/libraries/arcana/src/blocks/PlayerPayPopup/index.ts"

import { useUnit } from 'effector-react'
import { $playerPaymentPopupTranslations } from './translations'

interface PlayerPaymentPopupParams {
  smallPlayer?: boolean
  isFullscreen?: boolean
  onSubmit?: () => void
}

export const PlayerPaymentPopup = ({
  smallPlayer,
  isFullscreen,
  onSubmit,
}: PlayerPaymentPopupParams) => {
  const { title, subtitle, button } = useUnit($playerPaymentPopupTranslations)

  return (
    <PlayerPayPopup
      title={title}
      subtitle={subtitle}
      smallPlayer={smallPlayer}
      isFullscreen={isFullscreen}
      buttonTitle={button}
      onClick={onSubmit}
    />
  )
}
